import { render, staticRenderFns } from "./WorkflowGridFiltersCpt.vue?vue&type=template&id=35288f84&"
import script from "./WorkflowGridFiltersCpt.vue?vue&type=script&lang=ts&"
export * from "./WorkflowGridFiltersCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports